import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {
  SkippedInspectionsComponent
} from "./components/skipped-inspection/skipped-inspections.component";
import {FormsModule} from "@angular/forms";
import {NgxPaginationModule} from "ngx-pagination";

@NgModule({
  imports: [CommonModule, FormsModule, NgxPaginationModule],
  declarations: [SkippedInspectionsComponent],
  exports: [
    SkippedInspectionsComponent
  ]
})
export class SkippedInspectionsModule {
}
